<div class="modal-header">
  <div>
    <span *ngIf="serviceName" class="service-title">{{ serviceName }}</span>
    <h4 class="modal-title">{{ currentItem?.documentName }}</h4>
  </div>
  <div class="d-flex align-items-center align-self-start modal-controls">
    <button type="button" class="btn btn-ghost" (click)="toggleMaximize()">
      <i class="far fa-window-maximize" *ngIf="!maximize"></i>
      <i class="far fa-window-minimize" *ngIf="maximize"></i>
    </button>
    <button
      type="button"
      class="btn btn-ghost close btn-red"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    >
      <i class="far fa-times"></i>
    </button>
  </div>
</div>
<div class="modal-body">
  <div class="object-container" [ngClass]="{ maximize: maximize }">
    <object
      *ngFor="
        let item of items
          | paginate
            : {
                id: 'docs-pagination',
                itemsPerPage: 1,
                currentPage: currentPage,
                totalItems: items.length
              }
      "
      [data]="item.previewDoc | safe: 'resourceUrl'"
      class="doc_preview_object"
    ></object>
  </div>
</div>
<div class="modal-footer">
  <pagination-controls
    id="docs-pagination"
    class="list-pagination"
    [autoHide]="true"
    (pageChange)="onPageChange($event)"
    [previousLabel]="globalStateProviderService.previousLabel"
    [nextLabel]="globalStateProviderService.nextLabel"
  ></pagination-controls>
  <a
    i18n="@@Document download"
    [download]="currentItem?.documentName"
    [href]="currentItem?.previewDoc | safe: 'resourceUrl'"
    type="button"
    class="btn btn-primary btn-blue"
    >Document download</a
  >
</div>
